import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
const toString = v => v;
const tag = v => v.type;
const showTag = Data$dShow.showString;
const sameLabelsNil = {};
const sameLabelsCons = () => ({});
const sameLabels = () => () => () => () => ({convert: v => v});
const ordTag = Data$dOrd.ordString;
const mkTag = dictIsSymbol => () => p => dictIsSymbol.reflectSymbol(p);
const match = () => () => () => elim => v => Record$dUnsafe.unsafeGet(v)(elim);
const eqTag = Data$dEq.eqString;
const encodeTag = Foreign$dGeneric$dClass.stringEncode;
const elimTagNil = {};
const elimTagCons = () => ({});
const convert = dict => dict.convert;
const constructVariantNil = {};
const constructVariantCons = () => ({});
const construct = dictFunctor => () => () => () => elim => v => dictFunctor.map(value => ({type: v, value}))(Record$dUnsafe.unsafeGet(v)(elim));
export {
  construct,
  constructVariantCons,
  constructVariantNil,
  convert,
  elimTagCons,
  elimTagNil,
  encodeTag,
  eqTag,
  match,
  mkTag,
  ordTag,
  sameLabels,
  sameLabelsCons,
  sameLabelsNil,
  showTag,
  tag,
  toString
};
